/* eslint-disable max-len */
import Vue from 'vue';
import axios from 'axios';
import VueRouter from 'vue-router';

import store from '@/store';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/Home.vue'),
    meta: { requiresAuth: true, home: true },
  },
  {
    path: '/signin',
    name: 'signin',
    beforeEnter: async (to) => {
      try {
        const authURL = await axios.get('/auth/signin', { withCredentials: true });
        if (to.query.redirect) localStorage.setItem('redirect', to.query.redirect);
        window.location = authURL.data;
      } catch (error) {
        console.log(error);
        console.log(error.response);
        // next({ name: 'signin' });
      }
    },
  },
  {
    path: '/signin-cognito',
    name: 'signin cognito',
    component: () => import('../views/LoginCognito.vue'),
    beforeEnter: async (to, from, next) => {
      if (to.query.redirect) localStorage.setItem('redirect', to.query.redirect);
      return next();
    },
  },
  {
    path: '/sign-in/callback',
    name: 'callback sso',
    beforeEnter: async (to, from, next) => {
      try {
        await axios.post(`/auth/callback/sso?code=${to.query.code}`, {}, { withCredentials: true });
        const redirect = localStorage.getItem('redirect');
        if (redirect) {
          localStorage.removeItem('redirect');
          next({ path: redirect });
        } else next({ name: 'home' });
      } catch (error) {
        console.log(error);
        console.log(error.response);
        next({ path: `/unauthorized${error.response ? `?email=${error.response.data.message}` : ''}` });
        // next({ name: 'signin' });
        // next({ name: 'signin' });
      }
    },
  },
  {
    path: '/callback',
    name: 'callback',
    beforeEnter: async (to, from, next) => {
      try {
        await axios.get(`/auth/callback?code=${to.query.code}`, { withCredentials: true });
        const redirect = localStorage.getItem('redirect');
        if (redirect) {
          localStorage.removeItem('redirect');
          next({ path: redirect });
        } else next({ name: 'home' });
      } catch (error) {
        console.log(error);
        console.log(error.response);
        next({ path: `/unauthorized${error.response ? `?email=${error.response.data.message}` : ''}` });
        // next({ name: 'signin' });
        // next({ name: 'signin' });
      }
    },
  },
  {
    path: '/unauthorized',
    name: '401',
    component: () => import('../views/401.vue'),
  },
  {
    path: '/forbidden',
    name: '403',
    component: () => import('../views/403.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/signout',
    name: 'signout',
    beforeEnter: async (to, from, next) => {
      try {
        store.commit('profile/setUserLoggedIn', null);
        const response = await axios.get('/auth/signout', { withCredentials: true });
        const url = response.data.urlLogout;

        if (url) {
          window.location.href = url;
        } else {
          next({ name: 'signin cognito' });
        }
      } catch (error) {
        console.log(error);
        console.log(error.response);
        // next({ name: 'signin' });
        next({ name: 'home' });
      }
    },
  },
  {
    path: '/project-startup',
    name: 'project-startup',
    component: () => import('../views/ProjectCreator.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/project-startup/members',
    name: 'project-startup by ids add members',
    component: () => import('../views/ProjectCreator.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/project-startup/structure',
    name: 'project-startup by ids structure',
    component: () => import('../views/ProjectCreator.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/project-startup/:projectId/structure',
    name: 'project-startup by id structure',
    component: () => import('../views/ProjectCreator.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/project-startup/:projectId/folder-permissions',
    name: 'project-startup by id folder permissions',
    component: () => import('../views/ProjectCreator.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/project-startup/:projectId/members',
    name: 'project-startup by id add members',
    component: () => import('../views/ProjectCreator.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/projects-administration',
    name: 'projects-administration',
    component: () => import('../views/projects-administration/App.vue'),
    redirect: { name: 'projects-administration projects' },
    meta: { requiresAuth: true },
    children: [
      {
        path: 'projects',
        name: 'projects-administration projects',
        component: () => import('../views/projects-administration/Projects.vue'),
      },
      {
        path: 'account-users',
        name: 'projects-administration account users',
        component: () => import('../views/projects-administration/AccountUsers.vue'),
      },
      {
        path: 'upgrade-request/:id/:action',
        name: 'projects-administration upgrade-request',
        component: () => import('../views/projects-administration/UpgradeRequest.vue'),
      },
    ],
  },
  {
    path: '/app-settings',
    name: 'app-settings',
    component: () => import('../views/setting/App.vue'),
    redirect: { name: 'app-settings application access' },
    meta: { requiresAuth: true },
    children: [
      {
        path: 'application-access',
        name: 'app-settings application access',
        component: () => import('../views/setting/ApplicationAccess.vue'),
      },
      {
        path: 'folders-structure',
        name: 'app-settings folders structure',
        component: () => import('../views/setting/FoldersStructure.vue'),
      },
      {
        path: 'email-notifications',
        name: 'app-settings email notifications',
        component: () => import('../views/setting/EmailNotifications.vue'),
      },
      {
        path: 'design-scope',
        name: 'app-settings project types',
        component: () => import('../views/setting/ProjectTypes.vue'),
      },
      {
        path: 'project-creator',
        name: 'app-settings project creator',
        component: () => import('../views/setting/ProjectCreator.vue'),
      },
      {
        path: 'activity-log',
        name: 'app-settings activity log',
        component: () => import('../views/setting/ActivityLog.vue'),
      },
      {
        path: 'help-catalog',
        name: 'app-settings help',
        component: () => import('../views/setting/Help.vue'),
      },
      {
        path: 'transfer-settings',
        name: 'app-settings transfer',
        component: () => import('../views/setting/Transfer.vue'),
      },
      {
        path: 'request-re-collaboration',
        name: 'app-settings request re-collaboration',
        component: () => import('../views/setting/RequestReCollaboration.vue'),
      },
    ],
  },
  {
    path: '/publish-model',
    name: 'publish-model',
    component: () => import('../views/Publish.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/international-framework-content',
    name: 'international-framework-content',
    component: () => import('../views/ViewerDocumentTransfer.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/viewer',
    name: 'viewer',
    component: () => import('../views/Viewer.vue'),
    meta: { requiresAuth: true },
    beforeEnter: async (to, from, next) => {
      store.commit('viewer/setSelectedOption', undefined);
      store.commit('viewer/setSelectedFile', {});
      store.commit('viewer/setLoadingModel', false);
      store.commit('viewer/setIsModelCorrect', true);
      store.commit('viewer/setDocumentId', null);
      store.commit('viewer/setViewsModel', []);
      store.commit('viewer/setThumbnailViews', {});
      store.commit('viewer/setSelectedView', null);
      store.commit('viewer/setCredentialsViewer', {
        token: null,
        timeInSeconds: null,
      });
      next();
    },
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('../views/Dashboard.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/visor-panoramas/:panoramasId/point/:pointId',
    name: 'visor-panorama detail',
    component: () => import('../views/visor-panorama/VisorPanoramaDetail.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/access-projects',
    name: 'access-projects',
    component: () => import('../views/Accessprojects.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/access-projects/:token/:action',
    name: 'access-projects action',
    meta: { requiresAuth: true },
    component: () => import('../views/RequestAccessAction.vue'),
  },
  {
    path: '/viewer/:projectId/item/:versionId',
    name: 'viewer model',
    component: () => import('../views/Viewer.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/viewer/:token',
    name: 'viewer model shared',
    component: () => import('../views/Viewer.vue'),
  },
  {
    path: '*',
    name: '404',
    component: () => import('../views/404.vue'),
    meta: { requiresAuth: true },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  // const { referer } = req.headers;
  // if (!referer || !config.links_referrers.split(',').some(linkReferer => referer.includes(linkReferer))) return res.render('pages/no-authorized', { title: 'Error', isAuthenticated: false, email: 'unknown' });
  if (to.matched.some(record => record.meta.requiresAuth) && !store.getters['profile/isLoggedIn']) {
    try {
      await store.dispatch('profile/retrieveProfile');

      if (!store.getters['profile/isLoggedIn']) {
        return next({
          path: '/signin-cognito',
          query: { redirect: to.fullPath },
        });
      }
    } catch (error) {
      return next({
        path: '/signin-cognito',
        query: { redirect: to.fullPath },
      });
    }
  }
  if (store.getters['profile/isLoggedIn']) {
    if (to.matched.some(record => record.meta.home)) {
      if (store.state.profile.userLoggedIn.can_not_access_home) {
        window.location.href = store.state.profile.userLoggedIn.redirect_url;
        return {};
      }
    }
    const exceptions = ['home', 'access-projects action', '404', '401', '403', 'signout', 'signin cognito', 'visor-panorama detail'];
    if (exceptions.includes(to.name)) return next();
    const serviceName = to.name.split(' ')[0].replaceAll('-', '_');
    const services = store.state.profile.userLoggedIn.services
      .map((service) => {
        const keyService = Object.keys(service).find(key => (key !== 'permissions' && key !== 'conditions'));
        return { [keyService]: service[keyService] };
      })
      .filter(service => Object.values(service)[0])
      .map(service => Object.keys(service)[0]);

    if (services.includes(serviceName)) return next();
    return next({ name: '403' });
  }
  return next({});
});

export default router;
